import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ChipList from "components/ChipList";
import MDTypography from "components/MDTypography";
import { useAppContextController } from "context/AppContext";
import FormField from "layouts/applications/wizard/components/FormField";
import moment from "moment";
import { useSnackbar } from "notistack";
import { useMemo } from "react";
import { Controller, useWatch } from "react-hook-form";
import { useQueryClient } from "react-query";

const useStyle = makeStyles({
  editor: {
    height: 150,
  },
  box: {
    overflow: "visible",
    height: 550,
  },
});

const ConfirmStep = ({
  currentCustomer,
  clearErrors,
  setValue,
  control,
  getValues,
  errors,
  trigger,
  watch,
}) => {
  const { company, currentLoggedUser } = useAppContextController();
  const queryClient = useQueryClient();
  const classes = useStyle();
  const { enqueueSnackbar } = useSnackbar();

  const eventDate = useWatch({
    control,
    name: "eventDate",
  });
  const eventEndTime = useWatch({
    control,
    name: "eventEndTime",
  });
  const applicants = useWatch({
    control,
    name: "applicants",
  });
  const attendees = useWatch({
    control,
    name: "attendees",
  });

  const currentParticipants = useMemo(
    () => [
      ...(applicants ?? []).map((item) => ({
        title: `${item.firstName} ${item.lastName} (Candidate)`,
        key: item.id,
      })),
      ...(attendees ?? []).map((item) => ({
        title: `${item.firstName} ${item.lastName} (Interviewer)`,
        key: item.id,
      })),
    ],
    [applicants, attendees]
  );

  return (
    <>
      <Grid container item xs={12} rowSpacing={4}>
        <Grid container item xs={12} spacing={2}>
          <Grid item spacing={2} xs={12}>
            <MDTypography component="label" variant="h5" fontWeight="bold" color="info">
              Interview Summary
            </MDTypography>
          </Grid>
          <Grid container item spacing={2} xs={12}>
            <Grid item xs={6}>
              <Controller
                name="jobName"
                control={control}
                render={({ field }) => (
                  <FormField
                    InputLabelProps={{ tabIndex: -1 }}
                    type="text"
                    label="Job Name"
                    {...field}
                    disabled
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name="interviewLocation"
                control={control}
                render={({ field }) => (
                  <FormField
                    InputLabelProps={{ tabIndex: -1 }}
                    type="text"
                    label="Location"
                    {...field}
                    value={field.value ? field.value.label : "None"}
                    disabled
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid container item spacing={2} xs={12}>
            <Grid item xs={12}>
              <Controller
                name="eventDate"
                control={control}
                render={({ field }) => (
                  <FormField
                    InputLabelProps={{ tabIndex: -1 }}
                    type="text"
                    label="Date & Time"
                    {...field}
                    value={`${eventDate ? moment(eventDate).format("LL LT") : ""}${
                      eventEndTime ? ` - ${moment(eventEndTime).format("LT")}` : ""
                    }`}
                    disabled
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid item spacing={2} xs={12}>
            <MDTypography component="label" variant="h6" fontWeight="bold" color="info">
              Participants
            </MDTypography>
          </Grid>
          <Grid container item spacing={2} xs={12}>
            <Grid item xs={12}>
              <ChipList items={currentParticipants} title="" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ConfirmStep;
